import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IInterruptData {
    message?: string,
    yesCallback?: boolean,
    noCallback?: boolean,
    snoozeCallback?: boolean,
    target?: any
}

export interface IInterruptState {
    _interruptData: IInterruptData,
    _interruptOpen: boolean,
}

const initialState: IInterruptState = {
    _interruptData: {},
    _interruptOpen: false,
}

export const interruptSlice = createSlice({
    name: 'interruptSlice',
    initialState,
    reducers: {
        setInterrupt: (state, action: PayloadAction<IInterruptData>) => {
            state._interruptData = action.payload
            state._interruptOpen = !!action.payload.message
        },
        clearInterrupt: (state) => {
            state._interruptData = {}
            state._interruptOpen = false
        },
    },
})

export const {
    setInterrupt,
    clearInterrupt,
} = interruptSlice.actions

export default interruptSlice.reducer
